import React, { useState } from 'react'
import classes from "./styles/faq.module.css";
import minus from "./dumble.png";
import plus from "./dumble.png";

const Faq3 = () => {
    const [box1 , setBox1] = useState(false);
    const [box2 , setBox2] = useState(false);
    const [box3 , setBox3] = useState(false);

    const handlebox1 = () => {
        setBox1(!box1);
    }
    const handlebox2 = () => {
        setBox2(!box2);
    }

    const handlebox3 = () => {
        setBox3(!box3);
    }
    // const handlebox4 = () => {
    //     setBox4(!box4);
    // }

  return (
    <div className={classes.Container}>
      <div className={box1 ? classes.boxOpen : classes.box} onClick={handlebox1}>
            <div className={classes.upperCon}>
                <div>Do I have to follow a strict diet?</div>
                <div className={`${classes.logoCon} ${box1 ? classes.rotateIcon : ''}`}><img src={box1 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>No, we create <b>realistic meal plans</b> that t your daily routine. No extreme diets—just balanced nutrition that works for you.</div>
            </div>
        </div>


        <div className={`${box2 ? classes.boxOpen : classes.box} ${classes.boxMobile}`} onClick={handlebox2}>
            <div className={classes.upperCon}>
                <div>What if I have family meals, office parties, or travel plans?</div>
                <div className={`${classes.logoCon} ${box2 ? classes.rotateIcon : ''}`}><img src={box2 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>We guide you on <b>smart eating choices</b> so you stay on track even during events, social gatherings, or vacations.</div>
            </div>
        </div>



        <div className={`${box3 ? classes.boxOpen : classes.box} ${classes.boxMobile}`} onClick={handlebox3}>
            <div className={classes.upperCon}>
                <div>Will I have to cook separate meals for myself?</div>
                <div className={`${classes.logoCon} ${box3 ? classes.rotateIcon : ''}`}><img src={box3 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>No! Our meal plans are designed to t your <b>family’s diet</b> so you don’t have to cook separately.</div>
            </div>
        </div>

        {/* <div className={box4 ? classes.boxOpen : classes.box} onClick={handlebox4}>
            <div className={classes.upperCon}>
                <div>What if I miss a workout or have a busy week?</div>
                <div className={`${classes.logoCon} ${box4 ? classes.rotateIcon : ''}`}><img src={box4 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Life happens! The program is flexible, and you’ll receive guidance on how to stay on track even during busy times.</div>
            </div>
        </div> */}
    </div>
  )
}

export default Faq3;
